module.exports = __webpack_public_path__ + "img/scissors.9823e90b.png";